export default class productAccessory {

    id: string;
    variantId: string;
    name: string;
    imageUrl: string;
    unitPrice: number;
    showAccessory: boolean;
    productKey : string;
    
    constructor(accessory: any = {}) {
        this.id = accessory.id;
        this.variantId = accessory?.variants[0].id ?? '';
        const nameValue = accessory?.name;
        this.name = typeof nameValue === 'string' ? nameValue.trim() : '';
        this.imageUrl = accessory?.images?.[0]?.url ?? '';
        this.unitPrice = accessory?.price?.centAmount ?? 0;
        this.showAccessory = (this.unitPrice !== 0 && accessory?.slug)? true: false;
        this.productKey = accessory.productKey
    }
}   
